var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeadphones = function SvgHeadphones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.575 4.575A10.5 10.5 0 0 1 22.5 12v1.75h-3A3.25 3.25 0 0 0 16.25 17v3.75A3.25 3.25 0 0 0 19.5 24h1.25A3.25 3.25 0 0 0 24 20.75V12a12 12 0 0 0-24 0v8.75A3.25 3.25 0 0 0 3.25 24H4.5a3.25 3.25 0 0 0 3.25-3.25V17a3.25 3.25 0 0 0-3.25-3.25h-3V12a10.5 10.5 0 0 1 3.075-7.425m13.688 11.188a1.75 1.75 0 0 1 1.237-.513h3v5.5a1.75 1.75 0 0 1-1.75 1.75H19.5a1.75 1.75 0 0 1-1.75-1.75V17c0-.464.184-.91.513-1.237m-16.25 6.224A1.75 1.75 0 0 1 1.5 20.75v-5.5h3A1.75 1.75 0 0 1 6.25 17v3.75A1.75 1.75 0 0 1 4.5 22.5H3.25a1.75 1.75 0 0 1-1.237-.513",
    clipRule: "evenodd"
  })));
};
export default SvgHeadphones;